import { Box, Container,  Typography, Tab,  Button, MenuItem, Menu } from '@mui/material'
import React, { useState, useEffect, useContext } from 'react'
import {BsSearch, BsFillMoonStarsFill} from 'react-icons/bs';
import {RiVisaLine} from 'react-icons/ri';
import {GiStarsStack} from 'react-icons/gi';
import {SiYourtraveldottv} from 'react-icons/si';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import './holidays.css';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useUserAuth } from '../login/userAuthContext';
import { useNavigate } from 'react-router';
import CityMenu from '../dropdowns/dropdownCity';
import { NavigatorContext } from '../../contexts/NavigatorContext';

const months = ["Jan'", "Feb'", "Mar'", "April", "May", "June", "July", "Aug'", "Sept'", "Oct'", "Nov'", "Dec'"];
const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const saerchBtnStyle = {
  position: 'absolute',
  left: '40%',
  top: '62%',
  fontSize: '30px',
  borderRadius: '30px',
  width: '300px',
  marginTop:'100px',
}
const numberArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export default function Holiday() {
  const [date, setDate] = useState();
  const [userDate, setUserDate] = useState(new Date());
  const {user} = useUserAuth();
  const [city, setCity] = useState("Delhi");
  const [cityClicked, setCityClicked] = useState(true);
  const [city2, setCity2] = useState("Goa");
  const [destClicked, setDestClicked] = useState(true);
  const {setParam} = useContext(NavigatorContext);
  useEffect(()=>{
    setParam('holiday');
  }, [])
  useEffect(()=>{
    setUserDate(new Date(date));
  }, [date])
const navbar= {
    width: '80vw',
    height:'120px',
    backgroundColor: 'white',
    position:'absloute',
    left: '0vw'  
}
const texter = {
    textTransform: "none",
    fontSize: '18px',
    fontWeight:'bold',
    paddingTop: '50px',
    width:'16vw',
    display:'flex',
    borderLeft:'2px solid #bbb',
    backgroundColor:'rgba(194, 239, 254,0.5)'
}

function LinkTab(props) {
    return (
      <Tab
        component="a"
        onClick={(event) => {
        }}
        {...props}
      />
    );
  }
  
function Appbar() {
    const [valueNav, setValueNav] = useState("search");
    const handleChange2 = (event, newValue)=> {
        setValueNav(newValue);
        event.stopPropagation();
    }
    const widthClass = {
        width: '80vw',
        position:'absolute',
        left:'20px'
    }
    return (
        <div style={widthClass}>
            <Container
            sx={navbar}
        >
        <TabContext value={valueNav} sx={navbar}>
        <Box 
        display='flex'
        sx={{ borderBottom: 1, borderColor:'white', width:"80vw"}}>
            <TabList onChange={handleChange2}
            sx={{width: '80vw',  justifyContent:'space-between'}}
            >
                <LinkTab sx={texter} icon={<BsSearch style={{fontSize:"25px"}}/>} label="Search" value="search"/>
                <LinkTab sx={texter} icon={<RiVisaLine style={{fontSize:"25px"}}/>} label="Easy Visa Destination" value="visa" />
                <LinkTab sx={texter} icon={<BsFillMoonStarsFill style={{fontSize:"25px"}}/>} label="Honeymoon" value="home" />
                <LinkTab sx={texter} icon={<GiStarsStack style={{fontSize:"25px"}}/>} label="New Arrival" value="train" />
                <LinkTab sx={texter} icon={<SiYourtraveldottv style={{fontSize:"25px"}}/>} style={{borderRight:'2px solid #bbb'}} label="Azerbaijan Unveiled" value="charter" />
            </TabList>
        </Box>
        </TabContext>
        </Container>
        </div>
  )
}
    function LocationCard(props){
      const handleLocation = ()=> {
        if(props.firstLine==="From City"){
          setCityClicked(true);
        }else{
          setDestClicked(true);
        }
      }
        return(
            <div className='locationHoliday' onMouseOver={handleLocation}>
                <Typography variant='body2' fontWeight='bold' sx={{fontFamily:'Poppins'}} onMouseOver={handleLocation}>{props.firstLine}</Typography>
                <Typography variant='h1' fontSize='40px' sx={{fontFamily:'Poppins'}} onMouseOver={handleLocation}>{props.selectCity}</Typography>
                <Typography variant='body2' fontWeight='bold' sx={{fontFamily:'Poppins'}} onMouseOver={handleLocation}>{props.country}</Typography>
            </div> 
        )
    }
    function TravellerCount(props){
      const [anchorEl, setAnchorEl] = React.useState(null);
      const open = Boolean(anchorEl);
      const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };
      const handleClose = () => {
        setAnchorEl(null);
      };
      const handleSelectTag = ()=>{
        setAnchorEl(null);
      }
      return (
        <div className='locationHoliday'>
          <Button
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            endIcon={<KeyboardArrowDownIcon />}
            sx={{textTransform:'none', textAlign:'left'}}
          >
            {props.guest}
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <MenuItem>
              <div className='traveller-apartHoliday'>
                <h3>{props.select1}</h3>
                <div>
                  <select onSelect={handleSelectTag}>
                    {numberArray.map(el=>{
                      return <option key={el}>{el}</option>
                    })}
                  </select>
                </div>
              </div>
            </MenuItem>
            <MenuItem>
            <div className='traveller-apartHoliday'>
                <h3>{props.select2}</h3>
                <div>
                  <select onSelect={handleSelectTag}>
                    {numberArray.map(el=>{
                      return <option key={el}>{el}</option>
                    })}
                  </select>
                </div>
              </div>
            </MenuItem>
          </Menu>
          <div style={{display:'flex'}}><h4>Select Rooms</h4></div>
        </div>
      );
    }
    function UtilityCard(props){
        const [anchorEl, setAnchorEl] = React.useState(null);
        const open = Boolean(anchorEl);
        const handleClick = (event) => {
            setAnchorEl(event.currentTarget);
        };
        const handleClose = () => {
            setAnchorEl(null);
        };
        useEffect(()=>{
          setAnchorEl(null);
      }, [date]);
      
        const handleDateChange = (e)=>{
          setDate(e.target.value);
        }
        
        return (
        <div style={{textAlign:'center'}}>
        <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{textTransform:'none'}}
      >
        {props.options}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem><input type='date' onChange={handleDateChange}/></MenuItem>
      </Menu>
    </div>
    )
    }
    function DateCard(props){
        return (
          <div className='dateCardHoliday'>
            <UtilityCard options={props.options} />

            {date ? <div>
            <Box display='flex'>
            <Typography variant='h1' fontSize='30px' lineHeight='0.5'>{userDate.getDate()}</Typography>
            <Typography variant='h3' fontSize='23px'>{months[userDate.getMonth()]}</Typography>
            <Typography variant='h3' fontSize='23px'>{userDate.getFullYear()}</Typography>
            </Box>
            <Typography variant='body2' fontWeight='bold' textAlign='left'>{days[userDate.getDay()]}</Typography>
            </div> : 
            <div>
            <Box display='flex'>
            <Typography variant='h1' fontSize='30px' lineHeight='0.5'>{new Date().getDate()}</Typography>
            <Typography variant='h3' fontSize='23px'>{months[new Date().getMonth()]}</Typography>
            <Typography variant='h3' fontSize='23px'>{new Date().getFullYear()}</Typography>
            </Box>
            <Typography variant='body2' fontWeight='bold' textAlign='left'>{days[new Date().getDay()]}</Typography>
            </div>
          }
          </div>

        )
    }
    const navigate = useNavigate();
    const handleTickets = ()=> {
      if(user){
        navigate('/tickets/holiday');
      }else{
        navigate('/login');
      }
    }
  return (
    <div className='holidayCard' onClick={()=>setCityClicked(true)}>
     <div className='center-nav'><Appbar /></div>
     <div>
     <div className='sliderHoliday'>
           <Box display='flex'>
            <LocationCard firstLine={"From City"} selectCity={city} country={"India"} />
            <LocationCard firstLine={"To City/Country/Category"} selectCity={city2} />
            <DateCard options={'Departure Date'} enter={true} />
            <TravellerCount guest={"Rooms & Guest"} select1={"Adults"} select2 = {"Rooms"} />
           </Box>
        </div>
     </div>
     <Button variant='contained' sx={saerchBtnStyle} onClick={handleTickets}>SEARCH</Button>
    {cityClicked && <div className='positionCity1'><CityMenu setterFunc={setCity} removeMenu={setCityClicked}/></div>}
    {destClicked && <div className='positionCity2'><CityMenu setterFunc={setCity2} removeMenu={setDestClicked} /></div>}
    </div>
  )
}
